const PHONE_NUMBER_REGEXP = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]{6,15}$/;

export const isValidPhoneNumber = phoneNumber => {
    return PHONE_NUMBER_REGEXP.test(phoneNumber);
}